<h1>{{ title }}</h1>
<div *ngIf="view$ | async as view">
  <flo-video-scrubber-control
    *ngIf="isDVR"
    [currentTime]="view?.currentTime"
    [bufferAmount]="view?.bufferAmount"
    [duration]="view?.duration"
    [eventAnalytics]="view?.analytics"
    [isDVR]="isDVR"
    (pauseVideoOnSeeking)="_pauseVideoOnSeeking($event)"
    (videoPositionChange)="_videoPositionChange($event)"
  ></flo-video-scrubber-control>
  <div class="controls-container" data-test="video-controls">
    <div class="left pointer-ok align-items-start">
      <div *ngIf="showLiveBadge" [ngSwitch]="isLive$ | async" id="live-bdg">
        <i
          *ngSwitchCase="false"
          floAnalytics
          tagName="Player Control"
          events="click"
          [analyticsProperties]="view?.analyticPropsLiveBadge"
          floSvg="live_inactive"
          title="video is not live"
          (click)="_clickedLiveBadge()"
        ></i>
        <i *ngSwitchCase="true" floSvg="badge_live" title="video is live"></i>
      </div>
      <div *ngIf="isDVR">
        <i
          floAnalytics
          tagName="Player Control"
          events="click"
          [analyticsProperties]="view?.analyticPropsSkipBack"
          floSvg="back_10"
          title="skip backwards"
          (click)="_clickedSkipBackward()"
        ></i>
      </div>
      <div>
        <i
          floAnalytics
          tagName="Player Control"
          events="click"
          [analyticsProperties]="view?.analyticPropsPlayBtn"
          [hidden]="view?.isVideoPlaying"
          floSvg="vid_pause"
          title="pause video"
          (click)="_clickedPauseIcon()"
        ></i>
        <i
          floAnalytics
          tagName="Player Control"
          events="click"
          [analyticsProperties]="view?.analyticPropsPlayBtn"
          [hidden]="!view?.isVideoPlaying"
          floSvg="vid_play"
          title="play video"
          (click)="_clickedPlayIcon()"
        ></i>
      </div>
      <div *ngIf="isDVR">
        <i
          floAnalytics
          tagName="Player Control"
          events="click"
          [analyticsProperties]="view?.analyticPropsSkipForward"
          floSvg="forward_10"
          title="skip forwards"
          (click)="_clickedSkipForward()"
          [class.disabled]="isLive$ | async"
        ></i>
      </div>
      <flo-video-volume-control
        [volumeState]="view?.volumeState"
        (volumeView)="setVolumeState($event)"
        [eventAnalytics]="view?.analytics"
      ></flo-video-volume-control>
    </div>
    <div class="right pointer-ok align-items-start">
      <a
        class="typeform-share button"
        href="{{ typeFormUrl$ | async }}"
        data-mode="popup"
        data-size="70"
        data-submit-close-delay="0"
        target="_blank"
      >
        <i
          class="svg-icon-lg svg-vertical-align-middle text-secondary d-flex"
          floSvg="question-circle"
          floAnalytics
          tagName="Player Control"
          events="click"
          [analyticsProperties]="view?.analyticPropsStreamFeedback"
          title="stream feedback"
        ></i>
      </a>
      <flo-video-quality-control
        [eventAnalytics]="view?.analytics"
        (qualityChanged)="videoQualityChange($event)"
        [qualityControlState]="view?.qualityControl"
        class="icon-margin-left"
        #clickOutAvoid
      ></flo-video-quality-control>
      <i
        *floIfNotFullscreen="fullScreenElement"
        [floClickToEnterFullscreen]="fullScreenElement"
        data-test="live-video-fullscreen"
        floAnalytics
        tagName="Player Control"
        events="click"
        [analyticsProperties]="view?.analyticPropsFullScreen"
        floSvg="expand"
        title="to fullscreen"
      ></i>
      <i
        *floIfFullscreen="fullScreenElement"
        floClickToExitFullscreen
        floAnalytics
        tagName="Player Control"
        events="click"
        [analyticsProperties]="view?.analyticPropsFullScreen"
        floSvg="collapse"
        title="minimize fullscreen"
      ></i>
    </div>
  </div>
</div>
